// extracted by mini-css-extract-plugin
export default {"form":"QuoteForm_form__ogBoi","loading":"QuoteForm_loading__gyIuQ","control":"QuoteForm_control__8SqBM","actions":"QuoteForm_actions__I8AC6"};